import Input from './Input';
import InputGroup from './InputGroup';

export default Input;

export { InputGroup };
